import _definePage_default_0 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/broadcast.vue?definePage&vue'
import _definePage_default_3 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/license.vue?definePage&vue'
import _definePage_default_4 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/roles.vue?definePage&vue'
import _definePage_default_5 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/settings/external-apps.vue?definePage&vue'
import _definePage_default_6 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/settings/user-fields.vue?definePage&vue'
import _definePage_default_7 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/teams.vue?definePage&vue'
import _definePage_default_8 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/users.vue?definePage&vue'
import _definePage_default_9 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/wrapup/category.vue?definePage&vue'
import _definePage_default_10 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/wrapup/group-status.vue?definePage&vue'
import _definePage_default_11 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/wrapup/template.vue?definePage&vue'
import _definePage_default_12 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/calllist/create.vue?definePage&vue'
import _definePage_default_13 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/calllist/list.vue?definePage&vue'
import _definePage_default_14 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/campaign/create.vue?definePage&vue'
import _definePage_default_15 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/campaign/list.vue?definePage&vue'
import _definePage_default_16 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/dnc/index.vue?definePage&vue'
import _definePage_default_17 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/[...error].vue?definePage&vue'
import _definePage_default_18 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/login.vue?definePage&vue'
import _definePage_default_19 from 'E:/Coding/Tubtim/TubtimX/frontend/src/pages/managelist/index.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/admin',
    /* internal name: 'admin' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'broadcast',
        name: 'admin-broadcast',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/broadcast.vue'),
        /* no children */
      },
  _definePage_default_2
  ),
  _mergeRouteRecord(
      {
        path: 'license',
        name: 'admin-license',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/license.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: 'roles',
        name: 'admin-roles',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/roles.vue'),
        /* no children */
      },
  _definePage_default_4
  ),
      {
        path: 'settings',
        /* internal name: 'admin-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'external-apps',
            name: 'admin-settings-external-apps',
            component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/settings/external-apps.vue'),
            /* no children */
          },
  _definePage_default_5
  ),
  _mergeRouteRecord(
          {
            path: 'user-fields',
            name: 'admin-settings-user-fields',
            component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/settings/user-fields.vue'),
            /* no children */
          },
  _definePage_default_6
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'teams',
        name: 'admin-teams',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/teams.vue'),
        /* no children */
      },
  _definePage_default_7
  ),
  _mergeRouteRecord(
      {
        path: 'users',
        name: 'admin-users',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/users.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
      {
        path: 'wrapup',
        /* internal name: 'admin-wrapup' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'category',
            name: 'admin-wrapup-category',
            component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/wrapup/category.vue'),
            /* no children */
          },
  _definePage_default_9
  ),
  _mergeRouteRecord(
          {
            path: 'group-status',
            name: 'admin-wrapup-group-status',
            component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/wrapup/group-status.vue'),
            /* no children */
          },
  _definePage_default_10
  ),
  _mergeRouteRecord(
          {
            path: 'template',
            name: 'admin-wrapup-template',
            component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/admin/wrapup/template.vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      }
    ],
  },
  {
    path: '/calllist',
    /* internal name: 'calllist' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'calllist-create',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/calllist/create.vue'),
        /* no children */
      },
  _definePage_default_12
  ),
  _mergeRouteRecord(
      {
        path: 'list',
        name: 'calllist-list',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/calllist/list.vue'),
        /* no children */
      },
  _definePage_default_13
  )
    ],
  },
  {
    path: '/callwork',
    /* internal name: 'callwork' */
    /* no component */
    children: [
      {
        path: '',
        name: 'callwork',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/callwork/index.vue'),
        /* no children */
      },
      {
        path: 'leadprofile',
        /* internal name: 'callwork-leadprofile' */
        /* no component */
        children: [
          {
            path: ':id',
            name: 'callwork-leadprofile-id',
            component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/callwork/leadprofile/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/campaign',
    /* internal name: 'campaign' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'campaign-create',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/campaign/create.vue'),
        /* no children */
      },
  _definePage_default_14
  ),
  _mergeRouteRecord(
      {
        path: 'list',
        name: 'campaign-list',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/campaign/list.vue'),
        /* no children */
      },
  _definePage_default_15
  )
    ],
  },
  {
    path: '/dnc',
    /* internal name: 'dnc' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'dnc',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/dnc/index.vue'),
        /* no children */
      },
  _definePage_default_16
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_17
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_18
  ),
  {
    path: '/managelist',
    /* internal name: 'managelist' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'managelist',
        component: () => import('E:/Coding/Tubtim/TubtimX/frontend/src/pages/managelist/index.vue'),
        /* no children */
      },
  _definePage_default_19
  )
    ],
  }
]
